import { exists } from "@/lib/utilities";
import { validatePhoneNumber } from "@/lib/utilities/helpers/phone";
import { PhoneType, SmsOptInStatus } from "@/lib/utilities/enums";
import store from "@/store";

export function getContactName(Contact, Enums) {
  if (Contact) {
    if (!Contact.firstName && Contact.lastName) {
    }
    if (Contact.lastName || Contact.firstName) {
      return (
        (Contact.prefixTypeId >= 0 && Enums && Enums.prefix_type
          ? Enums.prefix_type.find(s => s.id === Contact.prefixTypeId).name +
            " "
          : "") +
        (Contact.firstName
          ? Contact.firstName[0].toUpperCase() +
            Contact.firstName.slice(1) +
            " "
          : "") +
        (Contact.middleName
          ? Contact.middleName.charAt(0).toUpperCase() + " "
          : "") +
        (Contact.lastName
          ? Contact.lastName[0].toUpperCase() + Contact.lastName.slice(1)
          : "") +
        (Contact.suffix ? " " + Contact.suffix : "") +
        (Contact.nickName
          ? " (" +
            Contact.nickName[0].toUpperCase() +
            Contact.nickName.slice(1) +
            ")"
          : "")
      );
    }
    if (
      !Contact.lastName &&
      !Contact.firstName &&
      Contact.businessName &&
      Contact.businessName != ""
    ) {
      return (
        Contact.businessName[0].toUpperCase() + Contact.businessName.slice(1)
      );
    }
    return "No Name";
  }
  return "No Name";
}

export function isContactTextable(Contact) {
  return (
    Contact &&
    !Contact.isDoNotText &&
    Contact.smsOptInStatusId != SmsOptInStatus.UserOptOut &&
    Contact.phones &&
    Contact.phones.filter(
      p =>
        (p.isMobile || p.phoneTypeId == PhoneType.CellPhone) &&
        !p.optOut &&
        !p.optOutSms
    ).length > 0
  );
}

export function isContactCellValid(Contact) {
  return (
    Contact &&
    Contact.phones &&
    Contact.phones.filter(
      p =>
        (p.isMobile || p.phoneTypeId == PhoneType.CellPhone) &&
        !p.optOut &&
        !p.optOutSms &&
        validatePhoneNumber(p) //
    ).length > 0
  );
}

export function CanEmailContact(CanEditContact, Contact) {
  return (
    CanEditContact &&
    Contact &&
    !Contact.isDoNotEmail &&
    Contact.emails &&
    Contact.emails.filter(e => !e.optOut).length > 0
  );
}

export function getRoleUsers(roles, StoreUsers) {
  if (!Array.isArray(StoreUsers) || !Array.isArray(roles)) return [];
  return StoreUsers.filter(
    su =>
      su &&
      su.PrimaryUserRole &&
      su.PrimaryUserRole.alertMinerRoleNameSystemName &&
      exists(su.PrimaryUserRole.alertMinerRoleNameSystemName) &&
      roles.includes(su.PrimaryUserRole.alertMinerRoleNameSystemName)
  ).sort((a, b) => {
    if (a && a.Name && b && b.Name) {
      a.Name.toLowerCase() - b.Name.toLowerCase()
    }
  });
}

export function getSortedEmails(emails) {
  if (!emails || emails.length == 0) return [];
  return [...emails].sort((email1, email2) => {
    if (email1.isPreferred != email2.isPreferred)
      return email2.isPreferred - email1.isPreferred;
    if (email1.optOut != email2.optOut) return email1.optOut - email2.optOut;
    else
      return (email1.email || "").toLowerCase() >
        (email2.email || "").toLowerCase()
        ? 1
        : -1;
  });
}

export function getContactPrimaryEmail(emails, includeOptOut) {
  let sortedEmails = getSortedEmails(emails);
  if (!includeOptOut)
    sortedEmails = sortedEmails.filter(email => !email.optOut);
  return sortedEmails.length > 0 ? sortedEmails[0] : null;
}

export function State(stateId) {
  if (
    stateId &&
    stateId > 0 &&
    store.getters.StateProvinces &&
    store.getters.StateProvinces.length > 0
  ) {
    return store.getters.StateProvinces.find(sp => sp.id == stateId)
      .abbreviation;
  }

  return "";
}

export function getPhoneByType(
  contact,
  typeId,
  phoneList = null,
  isPhones = false
) {
  if (!contact && !isPhones) return null;
  let phones = !isPhones ? contact.phones : phoneList;

  return phones &&
    phones.length > 0 &&
    phones.find(phone => {
      return phone.phoneTypeId == typeId;
    })
    ? phones.find(phone => {
        return phone.phoneTypeId == typeId;
      })
    : {
        phone: "",
        isMobile: false,
        optOutSms: false,
        isPreferred: false
      };
}

export function GetAllPhonesByType(phones) {
  return {
    home: getPhoneByType(null, PhoneType.HomePhone, phones, true),
    cell: getPhoneByType(null, PhoneType.CellPhone, phones, true),
    work: getPhoneByType(null, PhoneType.WorkPhone, phones, true)
  };
}

export function CreateSkeletalContactObject() {
  return {
    emails: null,
    canEmail: false,
    phones: null,
    notes: null,
    addresses: null,
    employments: null,
    additionalIncomes: null,
    banks: null,
    insurance: null,
    previousAddress: null,
    hasDLScanned: false,
    tags: null,
    surveyRating: null,
    accountId: null,
    accountPlatformId: null,
    avatarUrl: null,
    dealerId: null,
    dealerCode: null,
    pandoUserId: null,
    aaUserId: 0,
    contactTypeId: 1,
    salutoryTypeId: 0,
    firstName: null,
    middleName: null,
    lastName: null,
    nickName: null,
    businessName: "",
    suffix: null,
    cxmPurl: null,
    optOutAll: false,
    birthMonth: 0,
    birthDay: 0,
    preferredMethodTypeId: 0,
    preferredTimeOfDay: null,
    preferredDayOfWeek: 0,
    enterpriseValue: 0.0,
    enterpriseSalesValue: 0.0,
    enterpriseServiceValue: 0.0,
    storeValue: 0.0,
    storeSalesValue: 0.0,
    storeServiceValue: 0.0,
    isDoNotCall: false,
    isDoNotEmail: false,
    isDoNotText: false,
    isDoNotMail: false,
    isPreferredContactCall: false,
    isPreferredContactEmail: false,
    isPreferredContactText: false,
    isPreferredContactMail: false,
    isContactTimeEvening: false,
    isContactTimeMidDay: false,
    isContactTimeMorning: false,
    isMarkedHot: false,
    gender: null,
    updatedIdentity: null,
    prefixTypeId: 0,
    contactCultureId: null,
    smsOptInStatusId: 1,
    lastSmsOptInDate: "0001-01-01T00:00:00+00:00",
    driverLicenseNumber: null,
    driversLicenseIssue: null,
    driversLicenseExpiration: null,
    driversLicenseS3FrontPath: null,
    driversLicenseS3BackPath: null,
    driversLicenseS3AvatarPath: null,
    deleted: null,
    birthYear: null,
    isMarried: null,
    ssn: null,
    driversLicenseStateProvinceId: null,
    id: 0,
    prefixObj:null,
    suffixObj : null,
    birthMonthObj : null,
    birthDayObj : null,
    genderTypeObj : null,
    maritalStatus : null
  };
}



// WEBPACK FOOTER //
// ./src/lib/utilities/helpers/contact.js